import React from 'react';
import { Hero } from '../components/landing/Hero';
import { OpeningHook } from '../components/landing/OpeningHook';
import { ProblemSection } from '../components/landing/ProblemSection';
import { FailedApproaches } from '../components/landing/FailedApproaches';
import { MechanismReveal } from '../components/landing/MechanismReveal';
import { WhatYouGet } from '../components/landing/WhatYouGet';
import { AudienceSection } from '../components/landing/AudienceSection';
import { HowItWorks } from '../components/landing/HowItWorks';
import { ProofSection } from '../components/landing/ProofSection';
import { FAQSection } from '../components/landing/FAQSection';
import { FinalCTA } from '../components/landing/FinalCTA';
import { Footer } from '../components/landing/Footer';
export function CortisolSwitchPage() {
  return <main className="min-h-screen bg-slate-900 text-slate-50 selection:bg-amber-500/30 selection:text-amber-200" data-id="element-218">
      <Hero data-id="element-219" />
      <OpeningHook data-id="element-220" />
      <ProblemSection data-id="element-221" />
      <FailedApproaches data-id="element-222" />
      <MechanismReveal data-id="element-223" />
      <WhatYouGet data-id="element-224" />
      <AudienceSection data-id="element-225" />
      <HowItWorks data-id="element-226" />
      <ProofSection data-id="element-227" />
      <FAQSection data-id="element-228" />
      <FinalCTA data-id="element-229" />
      <Footer data-id="element-230" />
    </main>;
}